import { ICreateGameState } from './createGameContext';
import { CreateGameActionTypes, TCreateGameAction } from './createGameActions';

export const createGameReducer = (state: ICreateGameState, action: TCreateGameAction): ICreateGameState => {
	switch (action.type) {
		case CreateGameActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateGameActionTypes.SET_FILE:
			return {
				...state,
				fileId: action.payload.fileId,
				sourceUrlLocally: action.payload.sourceUrlLocally,
			};
		case CreateGameActionTypes.SET_FETCHED_DEVELOPERS:
			return {
				...state,
				fetchedDevelopers: action.payload.developers,
			};
		case CreateGameActionTypes.SET_ID_DEVELOPER:
			return {
				...state,
				IDSelectedDeveloper: action.payload.IDDeveloper,
			};
		case CreateGameActionTypes.REFETCH_DEVELOPERS:
			return {
				...state,
				needRefetchDevelopers: action.payload.needRefetch,
			};
		case CreateGameActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.categories,
			};
		case CreateGameActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDCategory,
			};
		case CreateGameActionTypes.CHANGE_APPLICATION_ID:
			return {
				...state,
				applicationId: action.payload.applicationId,
			};
		case CreateGameActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateGameActionTypes.CHANGE_VERSION_CODE:
			return {
				...state,
				versionCode: action.payload.versionCode,
			};
		case CreateGameActionTypes.CHANGE_VERSION_NAME:
			return {
				...state,
				versionName: action.payload.versionName,
			};
		case CreateGameActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case CreateGameActionTypes.CHANGE_APP_STORE_LINK:
			return {
				...state,
				appStoreLink: action.payload.appStoreLink,
			};
		case CreateGameActionTypes.CHANGE_PLAY_MARKET_LINK:
			return {
				...state,
				playMarketLink: action.payload.playMarketLink,
			};
		case CreateGameActionTypes.CHANGE_FILE_DATA:
			return {
				...state,
				fileData: action.payload.fileData,
			};
		case CreateGameActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.languages,
			};
		case CreateGameActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsSelectedLanguages: action.payload.IDsLanguages,
			};
		case CreateGameActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.data,
			};
		case CreateGameActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateGameActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CreateGameActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.translationTab,
			};
		case CreateGameActionTypes.SET_TRANSLATION_FIELDS:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case CreateGameActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case CreateGameActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				sourceUrlLocally: null,
				fetchedDevelopers: [],
				IDSelectedDeveloper: null,
				fetchedCategories: [],
				IDSelectedCategory: null,
				applicationId: '',
				name: '',
				versionCode: '',
				versionName: '',
				description: '',
				appStoreLink: '',
				playMarketLink: '',
				fileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				IDsSelectedLanguages: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
				translations: [],
			};
		default:
			return state;
	}
};
